import AddressManager, { ContractType } from '@kodiak-finance/address-manager'
import { SupportedChainId } from 'config/chains'
import { Address } from 'viem'

type AddressMap = { [chainId: number]: Address }

// BERA MIGRATION

const Bepolia = AddressManager.network(SupportedChainId.BEPOLIA)
const Bera = AddressManager.network(SupportedChainId.BERA)
const Robinhood = AddressManager.network(SupportedChainId.ROBINHOOD)

export const MULTICALL_3_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.Multicall3) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.Multicall3) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.Multicall3) as Address,
}

export const V3_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.UniswapV3Factory) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.UniswapV3Factory) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.UniswapV3Factory) as Address,
}

export const V2_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.UniswapV2Factory) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.UniswapV2Factory) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.UniswapV2Factory) as Address,
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.NonfungiblePositionManager) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.NonfungiblePositionManager) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.NonfungiblePositionManager) as Address,
}

export const V3_ROUTER_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.SwapRouter) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.SwapRouter) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.SwapRouter) as Address,
}

export const SWAP_ROUTER02_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.SwapRouter02) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.SwapRouter02) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.SwapRouter02) as Address,
}

export const V2_ROUTER_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.UniswapV2Router02) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.UniswapV2Router02) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.UniswapV2Router02) as Address,
}

export const MIXED_ROUTE_QUOTER_V1_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.MixedRouteQuoterV1) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.MixedRouteQuoterV1) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.MixedRouteQuoterV1) as Address,
}

export const QUOTER_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.QuoterV2) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.QuoterV2) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.QuoterV2) as Address,
}

export const TICK_LENS_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.TickLens) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.TickLens) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.TickLens) as Address,
}
export const MULTICALL_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.Multicall) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.Multicall) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.Multicall) as Address,
}

export const ISLAND_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.KodiakIslandFactory) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.KodiakIslandFactory) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.KodiakIslandFactory) as Address,
}

export const ISLAND_ROUTER_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.KodiakIslandRouter) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.KodiakIslandRouter) as Address,
  [SupportedChainId.ROBINHOOD]: Robinhood.require(ContractType.KodiakIslandRouter) as Address,
}

export const KODIAKFARM_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.KodiakFarmFactory) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.KodiakFarmFactory) as Address,
}

export const KODIAKFARM_IMPLEMENTATION_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.KodiakFarm) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.KodiakFarm) as Address,
}

export const XKDK_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.XKDK) as Address,
  [SupportedChainId.BERA]: '0x040ea7d4b559357425407fdfc3c774c5dfc04677' as Address,
}

export const PRE_TGE_XKDK_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.XKDK) as Address,
  [SupportedChainId.BERA]: Bera.require(ContractType.XKDK) as Address,
}

export const TOKEN_MIGRATOR_ADDRESSES: AddressMap = {
  // [SupportedChainId.BEPOLIA]: Bepolia.require(ContractType.TokenMigrator) as Address,
  [SupportedChainId.BERA]: '0x88eb43086eddf189856af7b00a09259598de8210' as Address,
}

export const AIRDROP_CLAIM_ADDRESSES: AddressMap = {
  [SupportedChainId.BERA]: '0xe5AFFFA15f977E84865BD645855934152a98d7e5' as Address,
}

export const BAULT_ROUTER_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: '0x0000000000000000000000000000000000000000',
  [SupportedChainId.BERA]: '0x89c8c594f8Dea5600bf8A30877E921a5E63DCCF3',
}

export const KX_ROUTER_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: '0x0000000000000000000000000000000000000000',
  [SupportedChainId.BERA]: '0x43Dac637c4383f91B4368041E7A8687da3806Cae',
  [SupportedChainId.ROBINHOOD]: '0xfd27998fa0eaB1A6372Db14Afd4bF7c4a58C5364',
}

export const CHARM_PERIPHERY_ADDRESSES: AddressMap = {
  [SupportedChainId.BERA]: '0xe2ac68fe15a8e64639aedcda30867cac04331a66',
}

export const KDK_ADDRESSES: AddressMap = {
  [SupportedChainId.BERA]: '0xc0d1ac00a30fa4e30e44afc7313d6312c87e21df',
}

export const BGT_ADDRESSES: AddressMap = {
  [SupportedChainId.BERA]: '0x656b95E550C07a9ffe548bd4085c72418Ceb1dba',
}

export const KODIAK_REWARDS_ADDRESSES: AddressMap = {
  [SupportedChainId.BERA]: '0xbc3dfe5ee6bce8b301a3661b3528a5c605eaf6af',
}

export const ENS_REGISTRAR_ADDRESSES: AddressMap = {
  [SupportedChainId.BERA]: '0x5b22280886a2f5e09a49bea7e320eab0e5320e28',
}

export const UNIVERSAL_BALANCE_HELPER_ADDRESSES: AddressMap = {
  [SupportedChainId.BERA]: '0x161b4b11eeafb13329e6ac43fffb1b908fa476e9',
  [SupportedChainId.ROBINHOOD]: '0x73597e9dC35FE63669Ced1E0af4fD06EE3f2CCe4',
}

export const V3_FEE_READER_ADDRESSES: AddressMap = {
  [SupportedChainId.BEPOLIA]: '0x0000000000000000000000000000000000000000',
  [SupportedChainId.BERA]: '0x1408324A215F51f09B7BaF49bee1E519D000d1B4',
  [SupportedChainId.ROBINHOOD]: '0xa5a9F4f637bEC66B3498D3BbcEa5430A38E810ce',
}
